import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/firebase.utils";

const GET_KITCHEN_CALLABLE_NAME = "onlineOrdering-getKitchen";

type GetKitchenResult =
  | { empty: true; kitchen: null; onlineConfigs: null }
  | { empty: false; kitchen: Record<string, unknown>; onlineConfigs: Record<string, unknown> | null };

/**
 * Loads kitchen data (by slug) and its onlineOrdersConfigs in a single
 * Cloud Function call, replacing the previous direct Firestore reads.
 */
export const getKitchenDB = async (kitchenSlug: string): Promise<GetKitchenResult> => {
  try {
    const fn = httpsCallable<{ kitchenSlug: string }, GetKitchenResult>(
      functions,
      GET_KITCHEN_CALLABLE_NAME,
    );
    const { data } = await fn({ kitchenSlug });
    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * @deprecated Config is now returned directly from `getKitchenDB`.
 * This stub exists only for backward compatibility and always returns
 * `{ onlineConfigs: null }`. Update callers to use `getKitchenDB` instead.
 */
export const getConfigDB = async (
  _kitchenId: string,
): Promise<{ onlineConfigs: null }> => {
  return { onlineConfigs: null };
};
